import {
  METER_ODOMETER,
  normalizeMeterType,
} from "./fieldAppMeterLabels";

function toFinite(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function daysUntil(dateValue) {
  if (!dateValue) return null;
  const raw = String(dateValue).slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) return null;
  const target = Date.UTC(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3])
  );
  const now = new Date();
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target - today) / 86400000);
}

/**
 * Quanto falta até a próxima manutenção.
 * Cálculo: alvo programado − última leitura conhecida (não é editável).
 * Unidade segue o medidor da máquina (h / km); se só houver data, usa dias.
 */
export function computeMaintenanceRemaining(row) {
  if (!row) {
    return { remaining: null, unit: "h", unitLabel: "h", kind: "hours" };
  }

  const meterType = normalizeMeterType(row.meterType || row.meter_type);

  if (meterType === METER_ODOMETER) {
    const target = toFinite(
      row.next_due_km != null
        ? row.next_due_km
        : row.targetKm != null
          ? row.targetKm
          : row.targetHourMeterDisplay != null
            ? row.targetHourMeterDisplay
            : row.targetHourMeter
    );
    const current = toFinite(
      row.currentOdometerDisplay != null
        ? row.currentOdometerDisplay
        : row.currentOdometer != null
          ? row.currentOdometer
          : row.currentHourMeterDisplay != null
            ? row.currentHourMeterDisplay
            : row.currentHourMeter
    );
    if (target != null && current != null) {
      return {
        remaining: target - current,
        unit: "km",
        unitLabel: "km",
        kind: "km",
      };
    }
  } else {
    const target = toFinite(
      row.targetHourMeterDisplay != null
        ? row.targetHourMeterDisplay
        : row.targetHourMeter
    );
    const current = toFinite(
      row.currentHourMeterDisplay != null
        ? row.currentHourMeterDisplay
        : row.currentHourMeter
    );
    if (target != null && current != null) {
      return {
        remaining: target - current,
        unit: "h",
        unitLabel: "h",
        kind: "hours",
      };
    }
  }

  const days = daysUntil(row.scheduled_date || row.scheduledDate);
  if (days != null) {
    return {
      remaining: days,
      unit: "d",
      unitLabel: "dias",
      kind: "days",
    };
  }

  return { remaining: null, unit: "h", unitLabel: "h", kind: "hours" };
}

export function formatMaintenanceRemaining(remainingInfo, t) {
  if (!remainingInfo || remainingInfo.remaining == null) return "—";
  const value = Number(remainingInfo.remaining);
  const formatted = value.toLocaleString("pt-BR", {
    maximumFractionDigits: 1,
  });
  if (remainingInfo.kind === "days") {
    if (value < 0) {
      return t("Atraso {{count}} dias", { count: Math.abs(Math.round(value)) });
    }
    if (value === 0) return t("Hoje");
    if (value === 1) return t("1 dia");
    return t("{{count}} dias", { count: Math.round(value) });
  }
  if (value < 0) {
    return `${formatted} ${remainingInfo.unitLabel}`;
  }
  return `${formatted} ${remainingInfo.unitLabel}`;
}

export function compareMaintenanceProximity(left, right) {
  const leftInfo = computeMaintenanceRemaining(left);
  const rightInfo = computeMaintenanceRemaining(right);
  const leftOverdue =
    Boolean(left && left.isOverdue) ||
    (leftInfo.remaining != null && leftInfo.remaining < 0);
  const rightOverdue =
    Boolean(right && right.isOverdue) ||
    (rightInfo.remaining != null && rightInfo.remaining < 0);

  if (leftOverdue && !rightOverdue) return -1;
  if (!leftOverdue && rightOverdue) return 1;

  const leftRemaining =
    leftInfo.remaining != null ? leftInfo.remaining : Number.POSITIVE_INFINITY;
  const rightRemaining =
    rightInfo.remaining != null ? rightInfo.remaining : Number.POSITIVE_INFINITY;
  if (leftRemaining !== rightRemaining) {
    return leftRemaining - rightRemaining;
  }

  const leftName = String((left && (left.equipment_name || left.name)) || "");
  const rightName = String((right && (right.equipment_name || right.name)) || "");
  return leftName.localeCompare(rightName, "pt-BR");
}

export function equipmentKeyFromScheduleRow(row) {
  if (!row) return "";
  if (row.equipmentId != null) return `id:${row.equipmentId}`;
  if (row.equipment_id != null) return `id:${row.equipment_id}`;
  return `name:${row.equipment_name || row.machineIdent || ""}`;
}
